import OCGatewayClient from "../client/OCGatewayClient";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Device } from "../models/Device";

export function useDeviceFirmwareChannelMutation(deviceId: string) {
    const queryClient = useQueryClient();

    const mutation = useMutation({
        mutationFn: async (firmwareChannel: string) => {
            await OCGatewayClient.request('updateDeviceFirmwareChannel', {
                deviceId,
                firmwareChannel
            });
            return firmwareChannel;
        },
        onMutate: async (firmwareChannel: string) => {
            await queryClient.cancelQueries({ queryKey: ['getDevice', deviceId] });

            const previousDevice = queryClient.getQueryData(['getDevice', deviceId]) as Device;

            queryClient.setQueryData(['getDevice', deviceId], (queryData: any) => {
                return Object.assign({}, queryData, { firmwareChannel });
            });

            return { previousDevice };
        },
        onError: (error, variables, context) => {
            queryClient.setQueryData(['getDevice', deviceId], (queryData: any) => {
                return Object.assign({}, queryData, { firmwareChannel: context?.previousDevice?.firmwareChannel });
            });
        },
        onSettled: () => {
            queryClient.invalidateQueries({ queryKey: ['getDevice', deviceId] });
        }
    });

    return mutation;
}
